// DOES NOT EDIT, generated file by '@openagenda/react-shared/scripts/extract-messages.js'

/* eslint-disable */

'use strict';

const br = require('./br.json');
const ca = require('./ca.json');
const de = require('./de.json');
const en = require('./en.json');
const es = require('./es.json');
const eu = require('./eu.json');
const fr = require('./fr.json');
const io = require('./io.json');
const it = require('./it.json');
const oc = require('./oc.json');

module.exports = {
  br,
  ca,
  de,
  en,
  es,
  eu,
  fr,
  io,
  it,
  oc,
};
